import serverOptimized from '@nykaa/utils/serverOptimized';


export default serverOptimized(() => import(/* webpackChunkName: "Wishlist.m" */'./Loadable'), '');
